export const PAYMENT_FREQUENCIES = {
  ONE_OFF: 'one_off',
} as const;

// Pointer to field map for API validation errors
export const POINTER_TO_FIELD_MAP: Record<string, string> = {
  client_iban: 'clientIban',
  zip_code: 'clientZipCode',
  address: 'clientAddress',
  city: 'clientCity',
  country_code: 'clientCountryCode',
  province_code: 'clientProvinceCode',
};

// Known error codes from the API that should be handled as field validation errors
export const KNOWN_ERROR_CODES = [
  'mandate_not_found',
  'mandate_already_signed',
  'required',
  'len',
  'invalid_iban',
  'sdd_disabled',
] as const;
